import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

function Intermediat_Check_table({handleClose}) {

  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const rows = [
    {
      sr: "01",
      date: "22 JAN 2025",
      weight: "0.01",
      std: "0.0103",
      obs1: "0.0102",
    },
    {
      sr: "02",
      date: "22 JAN 2025",
      weight: "0.02",
      std: "0.0202",
      obs1: "0.0203",
    },
  ];

  return (
    <>
    <section className="Imperiality_table">

    <div className="common_table_container theme_bg">
      <div className="table-responsive">
        <table className="common_table table table-striped customer_table">
          <thead>
            <tr>
              <th  rowSpan="2">Sr. No.</th>
              <th  rowSpan="2">Date</th>
              <th  rowSpan="2">Instrument</th>
              <th  rowSpan="2">Instrument ID</th>
              <th  rowSpan="2">Calibrate Instrument By</th>
              <th  rowSpan="2">Weight in Grams</th>
              <th  rowSpan="2">STD Value in grams</th>
              <th colSpan="5" className="text-center">
                Observations
              </th>
              <th  rowSpan="2">Mean</th>
              <th  rowSpan="2">Deviation</th>
            </tr>

            <tr>
              <th>OBS 01</th>
              <th>OBS 02</th>
              <th>OBS 03</th>
              <th>OBS 04</th>
              <th>OBS 05</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>{row.sr}</td>
                <td>{row.date}</td>
                <td>Ika Bomb Calorimeter</td>
                <td>TC TL/ BC-01</td>
                <td>D Patil</td>
                <td>{row.weight}</td>
                <td>{row.std}</td>

                <td>{row.obs1}</td>
                <td>
                  <Form.Group className="form_group">
                    <Form.Control
                      placeholder="Enter Value"
                    />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group className="form_group">
                    <Form.Control
                      placeholder="Enter Value"
                    />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group className="form_group">
                    <Form.Control
                      placeholder="Enter Value"
                    />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group className="form_group">
                    <Form.Control
                      placeholder="Enter Value"
                    />
                  </Form.Group>
                </td>

                <td>—</td>
                <td>—</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
       <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
    </section>
    </>
  );
}

export default Intermediat_Check_table;
